<template>
<div class="clearfix position-relative mb-5"> 
        <router-view ></router-view>  
    </div>
</template>
 
<script>

import {mapActions,mapGetters} from 'vuex'
import axios  from "axios";  



export default { 
 

 components:{
 },
    data(){
        return{            
        }
    },
    watch: {
        Aiuser: {
            handler(items) {
                if (items){
                    let frmCredit={
                        user_type:'AI-user',
                        user_id: items.id
                    } 
                    //this.getCoins(frmCredit).then(() => {});
                    }else{
                        
                    }
            },
            immediate: true,
            deep: true
            },
 
         },
    computed: { 
        ...mapGetters("Aiauth", ["Aiuser","CoinData"]), 
        ...mapGetters({ 
            showroomId: "Common/MyItem", 
        }),
        ...mapGetters(["errors"]),
    },
    methods:{ 
        ...mapActions("Aiauth", ["getAIUserData","getCoins" ]),

    },

    mounted() { 
        this.getAIUserData(); 
    },
     


}
</script>
<style  >
 

</style>